<script setup>
import CategorySelector from "@/components/table/CreateFeed/CategorySelector.vue";
import {onMounted, ref, watch} from "vue";
import {useSources} from "@/stores/sources-store";

const sourcesStore = useSources();

const props = defineProps({
  tagList: {
    type: [Array, null],
    required: true,
    default: null
  }
});

onMounted( async () => {
  categories.value = await sourcesStore.getTagsCategories();

  if (props.tagList) {
    tagList.value = props.tagList;
    // Инициализируем tagIds с поддержкой массивов тегов
    tagIds.value = props.tagList.flatMap((category) => {
      if (Array.isArray(category.tag_active)) {
        return category.tag_active.map(tag => tag.id);
      } else if (category.tag_active && category.tag_active.id) {
        return [category.tag_active.id];
      }
      return [];
    });
  }

  if (tagList.value.length === 0) {
    tagList.value = [{category_active: "Без категории", tag_list: [], tag_active: []}];
    await selectCategory(0, "");
  }
});

const tagIds = ref([]);

const emit = defineEmits(["update-tag-ids"]);

const categories = ref([]);

const tagList = ref([]);

const addCategory = async () => {
  tagList.value.push({category_active: "Без категории", tag_list: [], tag_active: []});
  await selectCategory(tagList.value.length - 1, "");
};

const selectCategory = async (index, selectedCategory) => {
  tagList.value[index].category_active = selectedCategory;
  tagList.value[index].tag_active = []; // Очищаем выбранные теги при смене категории
  tagList.value[index].tag_list = (await sourcesStore.getTagByCategory(selectedCategory))
    .sort((a, b) => a.name.localeCompare(b.name));
};

const deleteCategory = (index) => {
  // Удаляем ID тегов этой категории из общего списка
  const tagsToDelete = Array.isArray(tagList.value[index].tag_active) 
    ? tagList.value[index].tag_active 
    : (tagList.value[index].tag_active && tagList.value[index].tag_active.id ? [tagList.value[index].tag_active] : []);
  
  for (const tag of tagsToDelete) {
    const tagIdIndex = tagIds.value.indexOf(tag.id);
    if (tagIdIndex !== -1) {
      tagIds.value.splice(tagIdIndex, 1);
    }
  }
  
  tagList.value.splice(index, 1);
  emit("update-tag-ids", tagIds.value);
};

const selectedCategoryTag = (index, tags) => {
  // tags - это массив выбранных тегов из CategorySelector
  const tagsArray = Array.isArray(tags) ? tags : (tags && tags.id ? [tags] : []);
  
  // Удаляем старые теги этой категории из tagIds
  const oldTags = Array.isArray(tagList.value[index].tag_active) 
    ? tagList.value[index].tag_active 
    : (tagList.value[index].tag_active && tagList.value[index].tag_active.id ? [tagList.value[index].tag_active] : []);
  
  for (const oldTag of oldTags) {
    const idx = tagIds.value.indexOf(oldTag.id);
    if (idx !== -1) {
      tagIds.value.splice(idx, 1);
    }
  }
  
  // Добавляем новые теги
  for (const newTag of tagsArray) {
    if (!tagIds.value.includes(newTag.id)) {
      tagIds.value.push(newTag.id);
    }
  }
  
  tagList.value[index].tag_active = tagsArray;
  emit("update-tag-ids", tagIds.value);
};


</script>

<template>
  <div class="tag-selector">
    <div class="tag-selector__title">
      Теги
    </div>

    <div class="tag-selector__list">
      <div class="tag-selector__item">
        <div class="item__category">
          <CategorySelector
            v-for="(category, index) in tagList"
            :key="index"
            :tag-list="category.tag_list"
            :selected="category.category_active"
            :selected-tag="category.tag_active"
            :items="categories"
            @select-category-tag="args => selectedCategoryTag(index, args)"
            @delete-category="deleteCategory(index)"
            @select-category="selectedCategory => selectCategory(index, selectedCategory)"
          />
        </div>
      </div>
    </div>
    <div
      class="tag-selector__add-category"
      @click="addCategory"
    >
      Добавить категорию
    </div>
  </div>
</template>

<style scoped lang="scss">
.tag-selector {
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 8px;
  background: #F7F8FD;
  gap: 24px;

  &__add-category {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    padding: 6.4px 15px;
    border: 1px solid #1A64D4;
    color: #1A64D4;
    background: #FFFFFF00;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    user-select: none;

    &:hover {
      background: #E0F0FF;
      border-color: #E0F0FF;
    }
  }

  .item__category {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  &__title {
    font-size: 16px;
    font-weight: 500;
    color: #7B87A5;
  }
}

</style>